import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'

@Component({
  selector: 'app-more211services',
  templateUrl: './more211services.component.html',
  styleUrls: ['./more211services.component.css']
})
export class More211servicesComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  
  navigateMenu() {
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

}
